import { Entidad } from "./entidad";
import { TipoIncidencia } from "./tipo-incidencia";
import { Cotizacion } from "./cotizacion";


export class Incidencia {
    constructor(
        public IdIncidencia?: number,
        public entidad: Entidad = new Entidad(),
        public cotizacion: Cotizacion = null,
        public tipo: TipoIncidencia = {},
        public observacion?: string,
        public fechaAlta?: string,
        public created_by: string = '',
        public contacto: any=null
    ) { }
}

export class IncidenciaTree{
    constructor(
        public id: number,
        public titulo: string,
        public fecha_creacion: string,
        public creado_por: string,
        public observacion?: string
    ){}
}